import { render } from "./TariffsUniqueItem.vue?vue&type=template&id=44e08c39&scoped=true&ts=true"
import script from "./TariffsUniqueItem.vue?vue&type=script&lang=ts"
export * from "./TariffsUniqueItem.vue?vue&type=script&lang=ts"

import "./TariffsUniqueItem.vue?vue&type=style&index=0&id=44e08c39&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e08c39"]])

export default __exports__